module.exports = __webpack_public_path__ + "img/analytics.8a02709c.svg";